<template>
    <collapsible-block ref="collapsible"
                       :title-text="$t('businessOrders.labels.consigneeInformation')"
                       preview-only
    >
        <flex-row column-spacing="lg"
                  class="flex--no-wrap"
        >
            <div class="col">
                <value-wrapper :label="$t('businessOrders.labels.consigneeName')"
                               no-wrap
                >
                    {{ businessOrder.customerName | valueOrDash }}
                </value-wrapper>
            </div>
            <div class="col">
                <value-wrapper :label="$t('businessOrders.labels.consigneeAddress')"
                               no-wrap
                >
                    <consumer-address :order="businessOrder" />
                </value-wrapper>
            </div>
            <div class="col">
                <value-wrapper :label="$t('businessOrders.labels.consigneePhoneNumber')"
                               no-wrap
                >
                    {{ businessOrder.customerPhoneNumber | valueOrDash }}
                </value-wrapper>
                <value-wrapper :label="$t('businessOrders.labels.consigneeEmail')"
                               no-wrap
                >
                    {{ businessOrder.customerEmail | valueOrDash }}
                </value-wrapper>
            </div>
        </flex-row>
    </collapsible-block>
</template>

<script>
import CollapsibleBlock from '@/components/layout/CollapsibleBlock';
import ConsumerAddress from '../consumer-orders/ConsumerAddress';
import { ValueWrapper } from '@/components/form';

export default {
    components: {
        CollapsibleBlock,
        ValueWrapper,
        ConsumerAddress,
    },
    props: {
        businessOrder: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
